import React from "react";
import Modal from "react-modal";
import "../show-document/show-doc.scss";

class ShowDocsModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isOpen} className="doc-modal">
                    <div className="header dFlex">
                        <h5>
                            File :{" "}
                            {this.props.file != null && this.props.file.file}
                        </h5>
                        {this.props.file != null && (
                            <div className="opn-btn">
                                <a
                                    className="download-link"
                                    href={
                                        "/org-contract/download/" +
                                        this.props.file.id
                                    }
                                >
                                    {" "}
                                    <i className="fa fa-download pointer"></i>{" "}
                                </a>
                                <button
                                    className="close-modal"
                                    onClick={() => this.props.close()}
                                >
                                    {" "}
                                    <i className="fa fa-times pointer"></i>
                                </button>
                            </div>
                        )}
                    </div>
                    {this.props.file == null && <p className="loader"></p>}
                    {this.props.file != null && (
                        <>
                            {this.props.fileType == "pdf" ||
                            this.props.fileType == "PDF" ? (
                                <embed
                                    src={
                                        "data:application/pdf;base64," +
                                        this.props.file.encFile
                                    }
                                    className="file-src"
                                />
                            ) : (
                                <div className="msg-container">
                                    {this.props.file != null && (
                                        <a
                                            className="download-link"
                                            href={
                                                "/org-contract/download/" +
                                                this.props.file.id
                                            }
                                        >
                                            <h4>
                                                Preview not available please
                                                download.
                                            </h4>
                                        </a>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Modal>
            </div>
        );
    }
}

export default ShowDocsModal;
